import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AboutInfoRoutingModule } from './about-info-routing.module';
import { AboutInfoComponent } from './about-info.component';
import { AdsModule } from '../adcomponents/ad.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FreightComponent } from './freight/freight.component';
import { InvestorsComponent } from './investors/investors.component';
import { NewsComponent } from './news/news.component';
import { VendorsComponent } from './vendors/vendors.component';
import { GoogleChartsService } from './services/google-charts.service';
import { GooglePieChartService } from './services/google-pie-chart.service';
import { GoogleColumnChartsService } from './services/google-column-chart.service';
import { AnnouncementsComponent } from './investors/announcements/announcements.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [CommonModule, AboutInfoRoutingModule, AdsModule, NgbModule],
  declarations: [
    AboutInfoComponent,
    AboutUsComponent,
    ContactUsComponent,
    FreightComponent,
    InvestorsComponent,
    NewsComponent,
    VendorsComponent,
    AnnouncementsComponent
  ],
  providers: [
    GoogleChartsService,
    GooglePieChartService,
    GoogleColumnChartsService
  ]
})
export class AboutInfoModule {}
